module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyId')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2000) + "\n            "), (_vm.showSortArrow('AgencyId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyName')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2001) + "\n            "), (_vm.showSortArrow('AgencyName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyAddress')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2002) + "\n            "), (_vm.showSortArrow('AgencyAddress', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyAddress', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyAddress2')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2007) + "\n            "), (_vm.showSortArrow('AgencyAddress2', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyAddress2', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyCity')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2003) + "\n            "), (_vm.showSortArrow('AgencyCity', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyCity', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyState_Region')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2004) + "\n            "), (_vm.showSortArrow('AgencyState_Region', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyState_Region', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyPostalCode')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2005) + "\n            "), (_vm.showSortArrow('AgencyPostalCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyPostalCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyCountry')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2006) + "\n            "), (_vm.showSortArrow('AgencyCountry', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyCountry', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencySinceDate')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2008) + "\n            "), (_vm.showSortArrow('AgencySinceDate', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencySinceDate', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pagedAgencies), function(agency) {
    return _c('tr', {
      key: agency.AgencyId,
      class: {
        info: agency.AgencyGuid === _vm.selectedAgency.AgencyGuid,
        'text-bold': agency.AgencyTypeName === 'Lead',
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectAgency(agency)
        },
        "dblclick": function($event) {
          return _vm.openEditAgency(agency)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(agency.AgencyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyAddress2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.RegionCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyPostalCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyCountry))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencySince))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fcd3dfe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgencyManagement/AgencyManagementTable.vue
// module id = 642
// module chunks = 1 2